import * as React from 'react';
import * as d3 from 'd3';
import './InclinationChart.css';

interface InclinationChartProps {
    value: number;
    allowToggle: boolean;
    onToggle?: Function;
    initialClickedState?: boolean;
    skipAnimation?: boolean;
}

export class InclinationChart extends React.Component<InclinationChartProps, { clicked: boolean, value: number, isVisible: boolean }> {
    private inclinationRect: d3.Selection<Element | d3.EnterElement | Document | Window | null, {}, null, undefined>;
    private inclinationText: d3.Selection<Element | d3.EnterElement | Document | Window | null, {}, null, undefined>;
    private chartElement: HTMLDivElement | null = null;

    // minimum values so the inital load doesn't look weird
    private widthInPixelsOfEachNumber = 9;
    private minimumRectWidth = 24;
    private initialInclinationColor = '#00223e';
    private clickedColor = '#f00000';

    constructor(props: InclinationChartProps) {
        super(props);
        this.state = {
            clicked: this.props.initialClickedState === true,
            value: this.props.value,
            isVisible: false
        };
    }

    componentDidMount() {
        if (!this.props.skipAnimation) {
            this.updateInclinationChart(this.props.value);
        }

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    this.setState({ isVisible: true });
                    observer.disconnect();
                }
            },
            { threshold: 0.1 }
        );

        if (this.chartElement) {
            observer.observe(this.chartElement);
        }
    }

    componentWillReceiveProps(nextProps: InclinationChartProps) {
        this.setState({
            value: nextProps.value
        },            () => {
            if (!this.props.skipAnimation) {
                this.updateInclinationChart(nextProps.value);
            }
        });
    }

    updateInclinationChart(inclinationValue: number, fast?: boolean) {
        // const element = ReactDom.findDOMNode(this);

        if (inclinationValue > 99) {
            inclinationValue = 99;
        }

        if (inclinationValue < 0) {
            inclinationValue = 0;
        }

        // inclination value rectangle
        let inclinationFill =  '#002B54'; // $blue var(--blue)
        if (this.state.clicked) {
            inclinationFill = this.clickedColor;
        }

        let textOffset = 40;
        if (inclinationValue <= 9) {
            textOffset -= this.widthInPixelsOfEachNumber;
        }
    }

    clicked() {
        if (this.props.onToggle) {
            this.props.onToggle();
        }
        this.setState(
            {
                clicked: !this.state.clicked
            },
            () => {
                this.updateInclinationChart(this.state.value, true);
            });
    }

    render() {
        let inclinationValue = this.props.value;
        if (inclinationValue > 99) {
            inclinationValue = 99;
        }
        if (inclinationValue < 0) {
            inclinationValue = 0;
        }

        let inclinationFill = 'var(--blue)'; // $blue var(--blue)
        if (this.state.clicked) {
            inclinationFill = this.clickedColor;
        }

        const visibleMinimum = 3;
        const inclinationRectWidth = `${Math.max(inclinationValue, visibleMinimum)}%`;
        
        return (
            <div className={`inclination-chart ${this.props.skipAnimation ? 'skip-animation' : ''} ${this.state.isVisible ? 'visible' : ''}`}
                 onClick={(e) => this.props.allowToggle && this.clicked()} ref={(el) => this.chartElement = el}>
                <div className="chart-box" style={{width: inclinationRectWidth, backgroundColor: inclinationFill}}>
                    <div className="chart-text">{ Math.round(inclinationValue) }</div>
                </div>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/charts/InclinationChart.tsx